export default __webpack_public_path__ + "static/media/notifications.154920ad.svg";